/**
 * Fitreno "Build your stack" bundle block.
 *
 * Vanilla JS, no dependencies. Uses event delegation on `document` so it works
 * for every block instance and survives theme-editor re-renders.
 *
 * Cart integration (Horizon 3.x):
 *  - POST {routes.cart_add_url}.js with { items, sections, sections_url }.
 *  - Dispatch the theme's `cart:update` event (ThemeEvents.cartUpdate) on
 *    `document` with the same `detail` shape as the theme's CartAddEvent:
 *    cart-items-component morphs the drawer from `detail.data.sections` and
 *    cart-icon updates its bubble from `detail.data.itemCount`.
 *  - `cart-drawer-component` opens itself on that event when it has the
 *    `auto-open` attribute (theme setting). Otherwise we call its `open()`.
 *    If no drawer exists at all we fall back to navigating to the cart page.
 */
(function () {
  if (window.__frBundleReady) return;
  window.__frBundleReady = true;

  var EVENT_CART_UPDATE = 'cart:update';
  var EVENT_VARIANT_UPDATE = 'variant:update';

  /* ---------- helpers ---------- */

  function formatMoney(cents, format) {
    var value = Number(cents) || 0;
    var fmt = format || '${{amount}}';
    var match = /\{\{\s*(\w+)\s*\}\}/.exec(fmt);
    var key = match ? match[1] : 'amount';

    function group(number, precision, thousands, decimal) {
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? intPart + decimal + parts[1] : intPart;
    }

    var out;
    switch (key) {
      case 'amount_no_decimals':
        out = group(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        out = group(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        out = group(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        out = group(value, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        out = group(value, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        out = group(value, 0, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        out = group(value, 2, ' ', '.');
        break;
      default:
        out = group(value, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  function rows(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-fr-row]'));
  }

  function selectedRows(root) {
    return rows(root).filter(function (row) {
      var input = row.querySelector('.fr-bundle__check');
      return input && input.checked && row.getAttribute('data-available') === 'true';
    });
  }

  function refresh(root) {
    var selected = selectedRows(root);
    var total = selected.reduce(function (sum, row) {
      return sum + (Number(row.getAttribute('data-price-cents')) || 0);
    }, 0);

    var totalEl = root.querySelector('[data-fr-total]');
    if (totalEl) totalEl.textContent = formatMoney(total, root.getAttribute('data-money-format'));

    var button = root.querySelector('[data-fr-submit]');
    var text = root.querySelector('[data-fr-submit-text]');
    if (!button || !text || root.__frBusy) return;

    button.disabled = selected.length === 0;
    text.textContent =
      selected.length >= 2 ? root.getAttribute('data-label-multi') : root.getAttribute('data-label-single');
  }

  function showError(root, message) {
    var el = root.querySelector('[data-fr-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = !message;
  }

  function setBusy(root, busy) {
    var button = root.querySelector('[data-fr-submit]');
    var text = root.querySelector('[data-fr-submit-text]');
    root.__frBusy = busy;
    if (button) {
      button.disabled = busy;
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
    }
    if (busy && text) text.textContent = root.getAttribute('data-label-busy');
    if (!busy) refresh(root);
  }

  /** The variant currently selected in the page's product form for this section. */
  function currentVariantId(root) {
    var sectionId = root.getAttribute('data-section-id');
    var input = null;
    if (sectionId) {
      input = document.querySelector(
        'product-form-component[data-section-id="' + sectionId + '"] input[name="id"]'
      );
    }
    if (!input) input = document.querySelector('product-form-component input[name="id"]');
    if (input && input.value) return input.value;
    var currentRow = root.querySelector('[data-fr-row="current"]');
    return currentRow ? currentRow.getAttribute('data-variant-id') : null;
  }

  function cartItemsSectionIds() {
    var ids = [];
    var nodes = document.querySelectorAll('cart-items-component[data-section-id]');
    for (var i = 0; i < nodes.length; i++) {
      var id = nodes[i].getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    }
    return ids;
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().then(function (json) {
        return { ok: response.ok, status: response.status, json: json };
      });
    });
  }

  function openDrawer(root, detail) {
    var drawer = document.querySelector('cart-drawer-component');

    // Let the theme's own listeners (cart-items, cart-icon, auto-open drawer) react first.
    var event = new CustomEvent(EVENT_CART_UPDATE, { bubbles: true, detail: detail });
    document.dispatchEvent(event);

    if (!drawer) {
      window.location.href = root.getAttribute('data-cart-url') || '/cart';
      return;
    }
    if (drawer.hasAttribute('auto-open')) return; // already opened by the event
    if (typeof drawer.open === 'function') {
      drawer.open();
    } else if (typeof drawer.showDialog === 'function') {
      drawer.showDialog();
    } else {
      window.location.href = root.getAttribute('data-cart-url') || '/cart';
    }
  }

  /* ---------- actions ---------- */

  function submit(root) {
    if (root.__frBusy) return;
    showError(root, '');

    var items = [];
    selectedRows(root).forEach(function (row) {
      var id =
        row.getAttribute('data-fr-row') === 'current'
          ? currentVariantId(root)
          : row.getAttribute('data-variant-id');
      if (id) items.push({ id: Number(id), quantity: 1 });
    });

    if (!items.length) {
      showError(root, 'Select at least one product to add.');
      return;
    }

    var sectionIds = cartItemsSectionIds();
    var payload = { items: items };
    if (sectionIds.length) {
      payload.sections = sectionIds.join(',');
      payload.sections_url = window.location.pathname;
    }

    var addUrl = root.getAttribute('data-cart-add-url') || '/cart/add.js';
    var cartUrl = (root.getAttribute('data-cart-url') || '/cart') + '.js';

    setBusy(root, true);

    fetchJson(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    })
      .then(function (result) {
        if (!result.ok || (result.json && result.json.status)) {
          var msg =
            (result.json && (result.json.description || result.json.message)) ||
            'Something went wrong. Please try again.';
          throw new Error(msg);
        }
        var sections = result.json && result.json.sections;

        // /cart/add.js does not return item_count for multi-item adds; read the cart.
        return fetchJson(cartUrl, { headers: { Accept: 'application/json' } }).then(function (cart) {
          var count = cart.ok && cart.json ? Number(cart.json.item_count) || 0 : 0;
          return { cart: cart.json, count: count, sections: sections };
        });
      })
      .then(function (data) {
        setBusy(root, false);
        openDrawer(root, {
          resource: data.cart || {},
          sourceId: root.getAttribute('data-block-id') || 'fr-bundle',
          data: {
            source: 'fr-bundle',
            itemCount: data.count,
            productId: root.getAttribute('data-product-id'),
            sections: data.sections,
          },
        });
      })
      .catch(function (error) {
        setBusy(root, false);
        showError(root, (error && error.message) || 'Something went wrong. Please try again.');
      });
  }

  /** Keep the current-product row in sync when the shopper changes variant. */
  function onVariantUpdate(event) {
    var detail = event.detail || {};
    var data = detail.data || {};
    var html = data.html;
    var blocks = document.querySelectorAll('[data-fr-bundle]');

    for (var i = 0; i < blocks.length; i++) {
      var root = blocks[i];
      if (data.productId && String(data.productId) !== root.getAttribute('data-product-id')) continue;

      var row = root.querySelector('[data-fr-row="current"]');
      if (!row) continue;

      var fresh = null;
      if (html && typeof html.querySelector === 'function') {
        var blockId = root.getAttribute('data-block-id');
        var freshRoot = html.querySelector('[data-fr-bundle][data-block-id="' + blockId + '"]');
        fresh = freshRoot ? freshRoot.querySelector('[data-fr-row="current"]') : null;
      }

      if (fresh) {
        row.setAttribute('data-variant-id', fresh.getAttribute('data-variant-id') || '');
        row.setAttribute('data-price-cents', fresh.getAttribute('data-price-cents') || '0');
        row.setAttribute('data-available', fresh.getAttribute('data-available') || 'false');
        var priceEl = row.querySelector('[data-fr-price]');
        var freshPrice = fresh.querySelector('[data-fr-price]');
        if (priceEl && freshPrice) priceEl.textContent = freshPrice.textContent;
      } else if (detail.resource && typeof detail.resource.available !== 'undefined') {
        row.setAttribute('data-variant-id', detail.resource.id || '');
        row.setAttribute('data-available', detail.resource.available ? 'true' : 'false');
      } else if (detail.resource === null) {
        row.setAttribute('data-available', 'false');
      }
      refresh(root);
    }
  }

  /* ---------- wiring (delegated) ---------- */

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var button = target.closest('[data-fr-submit]');
    if (!button) return;
    var root = button.closest('[data-fr-bundle]');
    if (root) submit(root);
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!(target instanceof Element) || !target.classList.contains('fr-bundle__check')) return;
    var root = target.closest('[data-fr-bundle]');
    if (root) {
      showError(root, '');
      refresh(root);
    }
  });

  document.addEventListener(EVENT_VARIANT_UPDATE, onVariantUpdate);

  function init() {
    var blocks = document.querySelectorAll('[data-fr-bundle]');
    for (var i = 0; i < blocks.length; i++) refresh(blocks[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
